/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scenting_Grade_TitleInputs */

const vi_scenting_grade_title = /** @type {(inputs: Scenting_Grade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại phân loại lấy hương`)
};

/**

* @param {Scenting_Grade_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scenting_grade_title = /** @type {((inputs?: Scenting_Grade_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scenting_Grade_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scenting_grade_title(inputs)
});